<template>
    <div class="main" id="contBox">
        <el-row type="flex" class="row-bg" justify="center">
            <el-col :span="8" class="img6">
                <img src="../assets/images/img_6.png">
            </el-col>
        </el-row>
        <el-row type="flex" class="textBox marginBox" justify="center">
            <el-col :span="24" class="text">
                <p class="js">
                    <span>
                        <el-divider direction="vertical" class="textDer"></el-divider>二十年来，我们始终致力于为合作伙伴提供更高效的无线通信技术。
                    </span>
                    <span>在坚持深度自主研发，不断突破技术指标极限的基础上，持续迭代MANET技术体制，让“中国创造”走在世界前沿，成为技术革新引领者。</span>
                    <span>和峰科技愿携手合作伙伴，以未来之名，共创无线智连的美好新世界。</span>
                </p>
            </el-col>
        </el-row>
        <el-row class="imgBox">
            <el-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">
                <div  class="imgSty">
                    <img src="../assets/images/img_11.png" style="width: 9.8125rem;height: 10rem" alt="">
                </div>
                <p class="imgText">MANET介绍</p>
                <a class="imgA"  href="javascript:void(0)" @click="aClick('proCont','manet','MANET')">了解更多></a>
            </el-col>
            <el-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24" class="text">
                <div  class="imgSty">
                    <img src="../assets/images/img_12.png" style="width:15.6875rem;height: 7.375rem" alt="">
                </div>
                <p class="imgText">波形系列</p>
                <a class="imgA" href="javascript:void(0)" @click="aClick('contIndex','ky','')">了解更多></a>
            </el-col>
<!--            <el-col :xl="8" :lg="8" :md="8" :sm="24" :xs="24" class="text">
                <div  class="imgSty">
                    <img src="../assets/images/img_10.png" style="width:14.5rem ;height: 11.5rem" alt="">
                </div>
                <p class="imgText">模组系列</p>
                <a class="imgA" href="javascript:void(0)" @click="moduleHref('moduleList','core')">了解更多></a>
            </el-col>-->
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "Main",
        data () {
            return {
                id:""
            }
        },
        methods:{
            aClick(to,type,id){
                this.$router.push({
                    path:`/${to}/${type}/${id}`,
                });
            },
            moduleHref(to,type){
                this.$router.push({
                    path:`/${to}/${type}`,
                });
            }
        },
        mounted() {
            const windowH = window.innerHeight;
            const bodyH = document.body.clientHeight;
            let div = document.getElementById('contBox');
            if (windowH > bodyH){
                div.style.height = 'calc(100vh - 80px)';
            }
        }
    }
</script>

<style scoped>
    .main{
        /*height: calc(100% - 80px);*/
        overflow: hidden;
        padding-bottom: 4rem;
    }
    .img6{
        margin-top: 4.7rem;
    }
    .img6 img{
        width: 26.25rem;
        height: 5.875rem;
        margin: 0 auto;
    }
    .text{
        font-family: AlibabaPuHuiTi;
        font-size: 1.125rem;
        color: #888888;
    }
    .text .js{
        margin: 1rem 0 0 0;
    }
    .text p span{
        display: inline-block;
        line-height: 2.3375rem;
    }
    .text p span:last-child{
        /*font-weight: bold;*/
        color: #ffffff;
        font-family: AlibabaPuHuiTi-Bold;
    }
    .textDer{
        width: 3px;
        height: 1.5em;
        background-color: #ff0000;
    }

    .imgBox{
        margin-top: 2.625rem;
        overflow: unset;
        height: auto;
    }
    .imgSty{
        display: flex;
        height: 11.5625rem;
        overflow: hidden;
        justify-content: center;
        align-items: center;
    }
    .imgText{
        font-family: AlibabaPuHuiTi-Medium;
        font-size: 1.625rem;
        color: #ffffff;
        width: 100%;
        height: auto;
        text-align: center;
        margin: 1rem 0;
    }
    .imgText2{
        margin-top: -1rem;
    }
    .imgA{
        display: block;
        width: 7.3125rem;
        height: 2.25rem;
        margin: 0 auto;
        text-align: center;
        line-height: 2.25rem;
        font-size: 1rem;
        background: #e7211a;
        color: #ffffff;
        text-decoration: none;
        font-family: AlibabaPuHuiTi;
    }

    .marginBox{
        margin-top: 2rem;
    }
</style>
